import {Component, Input} from '@angular/core';

/**
 * Generated class for the ThinProgressBarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: 'thin-progress-bar',
  templateUrl: 'thin-progress-bar.html'
})
export class ThinProgressBarComponent {

  @Input('progress') progress;
  @Input('colorBar') colorBar;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/thin-progress-bar/thin-progress-bar.ts